import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createEmailTemplate = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createEmailTemplate($caseTypeId: Int!, $name: String!, $template: String!, $emailBodyTemplate: Boolean!, $templateWrapperId: Int, $defaultEmailBodyTemplate: Boolean, $sampleInput: String) {
        createEmailTemplate(caseTypeId: $caseTypeId, name: $name, template: $template, emailBodyTemplate: $emailBodyTemplate, templateWrapperId: $templateWrapperId, defaultEmailBodyTemplate: $defaultEmailBodyTemplate, sampleInput: $sampleInput) { message error lowLevelErrorMessage id createdAt }
      }`),
      variables: { caseTypeId: data.caseTypeId, name: data.name, template: data.template, emailBodyTemplate: data.emailBodyTemplate, templateWrapperId: data.templateWrapperId, defaultEmailBodyTemplate: data.defaultEmailBodyTemplate, sampleInput: data.sampleInput }
    })
  return response.data.createEmailTemplate
}

export const updateEmailTemplate = async (data) => {
  if (!data.template) { data.template = "" }
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation updateEmailTemplate($id: Int!, $name: String!, $template: String!, $emailBodyTemplate: Boolean!, $templateWrapperId: Int, $defaultEmailBodyTemplate: Boolean, $sampleInput: String) {
        updateEmailTemplate(id: $id, name: $name, template: $template, emailBodyTemplate: $emailBodyTemplate, templateWrapperId: $templateWrapperId, defaultEmailBodyTemplate: $defaultEmailBodyTemplate, sampleInput: $sampleInput) { message error lowLevelErrorMessage id createdAt }
      }`),
      variables: { id: data.id, name: data.name, template: data.template, emailBodyTemplate: data.emailBodyTemplate, templateWrapperId: data.templateWrapperId, defaultEmailBodyTemplate: data.defaultEmailBodyTemplate, sampleInput: data.sampleInput }
    })
  return response.data.updateEmailTemplate
}

export const deleteEmailTemplate = async (id) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteEmailTemplate($id: Int!) {
        deleteEmailTemplate(id: $id) { message error lowLevelErrorMessage }
      }`),
      variables: { id: id }
    })
  return response.data.deleteEmailTemplate
}

export const renderEmailTemplate = async (data) => {
  const payload = typeof data.payload === "string" ? JSON.parse(data.payload) : data.payload
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation renderEmailTemplate($id: Int!, $payload: JSON!) {
        renderEmailTemplate(id: $id, payload: $payload) { message error rendering }
      }`),
      variables: { id: data.id, payload }
    })
  return response.data.renderEmailTemplate
}
